import { Content } from '@angeplus/prever-component-lib';
import { HeaderHome } from 'components/headers/HeaderNotification';

import { PetHomeTextDisplay } from './PetHomeTextDisplay';
import { PetHomeServicesCardNavigationList } from './PetHomeServicesCardNavigationList';

export const PetHome = () => {
  return (
    <Content>
      <HeaderHome />
      <PetHomeTextDisplay />
      <PetHomeServicesCardNavigationList />
    </Content>
  );
};
